module.exports = __webpack_public_path__ + "static/media/electronicMedicalRecords.ce368fc6.jpg";